import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { MinimalCpgRetailer } from './PerformanceOverTimeCard';
import { MIN_RETAILER_COUNT } from '../../../domain/retailers';

export type MetricOption = {
  value: keyof Pick<
    MinimalCpgRetailer,
    'projectedIncrementalSales' | 'incrementalSalesLift' | 'totalProjectedSales'
  >;
  label: string;
};

const metricOptions = [
  { value: 'projectedIncrementalSales', label: 'Proj. Incr. Sales' },
  { value: 'incrementalSalesLift', label: 'Incr. Sales Lift' },
  { value: 'totalProjectedSales', label: 'Total Proj. Sales' },
] as const satisfies MetricOption[];

type CardTitleProps = {
  selectedMetric: MetricOption['value'];
  setSelectedMetric: (value: MetricOption['value']) => void;
};

export const CardTitle = (props: CardTitleProps) => {
  return (
    <Stack direction="row" gap="1rem" justifyContent="space-between">
      <Typography variant="h5">
        Performance Over Time by Top {MIN_RETAILER_COUNT} Retailers
      </Typography>
      <FormControl>
        <InputLabel>Metrics</InputLabel>
        <Select
          label="Metrics"
          size="small"
          value={props.selectedMetric}
          onChange={e => props.setSelectedMetric(e.target.value)}
          sx={{ minWidth: 200 }}
        >
          {metricOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};
